import { Result } from 'antd';
import { Constants } from '@CONFIG';

const AppError = () => {
  return <Result status="warning" title={Constants.ERROR_MESSAGE} />;
};

export default AppError;
